module.exports = {"contact":{"email":{"feedback":"feedback@yoop.app","sales":"sales@yoop.app","press":"info@yoop.app","support":"support@yoop.app"},"zendesk":{"base":"https://yoop.zendesk.com/hc/en-us","customPaths":{"virtualEvents":"/sections/360009057052-Virtual-Events"}},"social":{"instagram":"https://www.instagram.com/yoop/","twitter":"https://twitter.com/yoop","facebook":"https://www.facebook.com/yoopevents"}}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src426716145/src/modules/web/src/js/i18n/english/contact.en.i18n.json
// module id = 1200
// module chunks = 0